import { Pipe, PipeTransform } from '@angular/core';
import {AppComponent} from "../app.component";

@Pipe({
  name: 'PlayConfigLabelPipe'
})
export class PlayConfigLabelPipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): unknown {
    return value.split('|')
      .map((label_key) => AppComponent.getLabel(label_key)).join('/');
  }

}
